type ScrollToStoredElementProps = {
    id: string;
    offset?: number;
    behavior?: 'auto' | 'smooth';
};

export const scrollToStoredElement = ({ id, offset = 0, behavior = 'auto' }: ScrollToStoredElementProps) => {
    const el = document.getElementById(id);
    if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior });
    }
};

export const lockBodyScroll = (scrollYRef: { current: number }) => {
    scrollYRef.current = window.scrollY;
    document.body.style.top = `-${scrollYRef.current}px`;
    document.body.classList.add('no-scroll');
};

export type UnlockBodyScrollOptions = {
    scrollToTop?: boolean;
};

export const unlockBodyScroll = (scrollYRef: { current: number }, options: UnlockBodyScrollOptions = {}) => {
    document.body.classList.remove('no-scroll');
    document.body.style.top = '';
    const scrollY = options.scrollToTop ? 0 : scrollYRef.current;
    window.scrollTo({ top: scrollY });
};

export const cleanupBodyScrollLock = () => {
    document.body.classList.remove('no-scroll');
    document.body.style.top = '';
};
